var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pr yxtbiz-flex",
      class: _vm.module === "kng" ? "yxtbiz-kng-operator__single" : "",
    },
    [
      _c("div", { staticClass: "yxtbiz-kng-operator__form-wrap" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-w640" },
          [
            !_vm.hideFileHeader
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "yxtbiz-kng-operator__form-title ml15",
                      attrs: { id: "info_0" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("pc_kng_upload_tit_upload" /**上传文件 */)
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "yxtbiz-flex-center mb32 ml15 lh40" },
                    [
                      _c("yxt-svg", {
                        attrs: {
                          "remote-url": _vm.kngFileTypeIconUrl,
                          width: "20px",
                          height: "20px",
                          "icon-class": _vm.typeIcon,
                        },
                      }),
                      _c(
                        "span",
                        { staticClass: "ellipsis-1 ml12 color-gray-9" },
                        [_vm._v(_vm._s(_vm.info.fileName || _vm.info.title))]
                      ),
                      _vm.info._status === 0
                        ? _c("yxt-progress", {
                            staticClass: "ml32 yxtbiz-w100",
                            attrs: { percentage: _vm.info._percentage },
                          })
                        : _vm._e(),
                      _vm.info._status === 1
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "ml32 yxtbiz-flex-shrink color-danger-6",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.info._error) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      !_vm.useInBuyCourse && _vm.info.shareFlag !== 2
                        ? [
                            _vm.showReupload && !_vm.info._isReupload
                              ? _c(
                                  "yxt-button",
                                  {
                                    staticClass: "ml32",
                                    attrs: { type: "text" },
                                    on: { click: _vm.reupload },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_kng_lbl_reupload" /**重新上传 */
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.showDelete
                              ? _c(
                                  "yxt-button",
                                  {
                                    staticClass: "ml32",
                                    attrs: { type: "text" },
                                    on: { click: _vm.del },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_kng_lbl_delete" /** 删除 */
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.weikeVersionInfo.needUpgrade &&
                            !_vm.info.autoUpgrade
                              ? _c(
                                  "yxt-button",
                                  {
                                    staticClass: "ml32",
                                    attrs: {
                                      type: "primary",
                                      disabled: _vm.info.weiKeUpgrade,
                                    },
                                    on: { click: _vm.updateWeike },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.info.weiKeUpgrade
                                            ? _vm.$t(
                                                "pc_kng_upload_lbl_newweike_newcontentversion_text3"
                                              )
                                            : _vm.$t(
                                                "pc_kng_lbl_updateweike" /** 更新到新版 */
                                              )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.showWeikeEdit
                              ? _c(
                                  "yxt-button",
                                  {
                                    staticClass: "ml32",
                                    attrs: { type: "text" },
                                    on: { click: _vm.openWeikeUrl },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "pc_kng_upload_btn_editweikeonline" /** 编辑微课原文 */
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _c("kng-form", {
              ref: "form",
              class: _vm.hideFileHeader ? "yxtbiz-kng-mt-44" : "",
              attrs: { info: _vm.info },
            }),
          ],
          2
        ),
      ]),
      _vm.module !== "kng"
        ? _c("div", { staticClass: "yxtbiz-flex-1" })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "yxtbiz-kng-operator__loc-wrap" },
        [
          _c(
            "yxt-sticky",
            {
              staticClass: "yxtbiz-w105",
              attrs: { offset: _vm.getNavOffsetTop() },
            },
            [
              _c(
                "div",
                { staticClass: "yxtbiz-kng-operator__loc" },
                [
                  _vm._l(_vm.steps, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.value,
                        staticClass: "hand",
                        class: {
                          "color-primary-6": _vm.step === item.value,
                          mt16: index > 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.jump(item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.name) + "\n        "
                        ),
                      ]
                    )
                  }),
                  _c("div", { staticClass: "yxtbiz-kng-operator__loc-line" }, [
                    _c("div", {
                      staticClass: "yxtbiz-kng-operator__loc-block",
                      style: _vm.style(),
                    }),
                  ]),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "yxt-dialog",
        {
          attrs: {
            visible: _vm.showWeikeUpdateDialog,
            title: _vm.$t(
              "pc_kng_upload_lbl_newweike_newcontentversion_dialog_title" /* 更新说明 */
            ),
            "append-to-body": "",
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showWeikeUpdateDialog = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "pc_kng_upload_lbl_newweike_newcontentversion_dialog_text1" /* 1. 已完成的学员仅更新课件内容，完课状态、已发放的学时、学分不会退回 */
                )
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "pc_kng_upload_lbl_newweike_newcontentversion_dialog_text2" /* 2. 进行中的学员会更新课件内容、学时、学分 */
                )
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "pc_kng_upload_lbl_newweike_newcontentversion_dialog_text3" /* 3. 未开始的学员会直接使用新课件*/
                )
              )
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "yxt-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showWeikeUpdateDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_kng_common_btn_cancel")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.conformUpdateWeike },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pc_kng_upload_lbl_newweike_newcontentversion_dialog_btn_confirm" /* 确认更新*/
                      )
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }